/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Model_Column_DistributionInputs */



/**
* | output |
* | --- |
* | "Distribution (Input / Cached / Output)" |
*
* @param {Dashboard_Model_Column_DistributionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dashboard_model_column_distribution = /** @type {((inputs?: Dashboard_Model_Column_DistributionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Model_Column_DistributionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Verteilung (Input / Cached / Output)")
	return /** @type {LocalizedString} */ ("Distribution (Input / Cached / Output)")
});